import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

import { ReferentialType } from "../../../../_constants/referentialType.ts";
import { RootState } from "../../../../store";
import Input from "../Input.tsx";
import SelectForm from "../SelectForm.tsx";
import Textarea from "../Textarea.tsx";

const AdditionalPropertyForm = () => {
  const { control } = useFormContext();
  const referentials = useSelector(
    (state: RootState) => state.referentialReducer.referentials
  );
  return (
    <div className="bg-container d-flex flex-column gap-4">
      <h3 className="fw-bold main-title" style={{ fontSize: "24px" }}>
        Informations complémentaires
      </h3>
      <div className="d-flex flex-column gap-4">
        <SelectForm
          control={control}
          name="condition"
          label="État du bien :"
          options={referentials[ReferentialType.DWELLING_CONDITION].data}
          rules={{
            required: "Veuillez renseigner un état",
          }}
        />
        <Input
          control={control}
          label={"Lien de la visite virtuelle 360 :"}
          name={"linkVirtualVisit"}
          placeholder={"https://..."}
        />
        <Textarea
          control={control}
          name="comment"
          label="Commentaires :"
          placeholder="Cuisine neuve, peinture neuve, etc ..."
        />
      </div>
    </div>
  );
};

export default AdditionalPropertyForm;
